module.exports = __webpack_public_path__ + "img/122.7.c680a103.png";